export default "__VITE_ASSET__Jo3fs0UF__"